import { types } from 'mobx-state-tree';
import ProductTypeClass, { ProductType } from '../types/ProductTypeClass';

const CurrentOrderProduct = types
  .model('OrderProduct', {
    analytics_final_unit_price: types.number,
    analytics_starting_unit_price: types.number,
    analytics_total_price: types.number,
    final_unit_price: types.number,
    id: types.string,
    image_url: types.maybeNull(types.string),
    name: types.maybeNull(types.string),
    package_size: types.maybeNull(types.number),
    product_id: types.string,
    quantity: types.number,
    starting_unit_price: types.number,
    stock_unit: types.optional(types.string, ''),
    total_price: types.number,
    type: ProductType,
    variations: types.optional(types.array(types.string), [])
  })
  .views((self) => ({
    get isPhysicalProduct() {
      return self.type === ProductTypeClass.PHYSICAL;
    }
  }))
  .preProcessSnapshot(({ quantity, ...rest }) => ({
    quantity: Number(quantity),
    ...rest
  }));

export default CurrentOrderProduct;



// WEBPACK FOOTER //
// ./src/models/CurrentOrderProduct.js